<aside class="sb sidebar"
       [attr.data-collapsed]="isCollapsed ? 'true' : null"
       [ngClass]="{
        'd-none d-md-flex': !isSidebarOpen,
        'd-flex': isSidebarOpen,
        'sidebar-overlay-mobile': isSidebarOpen
      }">

  <!-- ── BRAND ───────────────────────────────────────────── -->
  <header class="sb__brand">
    <a routerLink="/" class="sb__brand-link" (click)="closeSidebar()" aria-label="skill2era">
      <!-- Logo officiel skill2era (cyan #28c1ec / blanc) — pour tous les tiers
           Expanded : logotype horizontal fourni par le client, détouré et
           recadré sur son tracé (le fichier d'origine est un carré à 65 % vide)
           Collapsed / mobile : SVG inline mark simplifié (path stylisé) -->
      <img src="assets/images/logo/skill2era-wordmark-white.png"
           alt="skill2era" class="sb__logo sb__logo--full" draggable="false"
           width="891" height="341">
      <img src="assets/images/logo/skill2era-mark-white.png"
           alt="" aria-hidden="true" class="sb__logo sb__logo--mark"
           draggable="false" width="256" height="256">
    </a>
  </header>

  <!-- Edge handle : bouton collapse flottant sur la bordure -->
  <button class="sb__edge-handle d-none d-lg-flex" type="button"
          (click)="toggleCollapsed()"
          [attr.aria-label]="(isCollapsed ? 'SIDEBAR.EXPAND' : 'SIDEBAR.COLLAPSE') | translate"
          [title]="(isCollapsed ? 'SIDEBAR.EXPAND' : 'SIDEBAR.COLLAPSE') | translate">
    <i class="fa-solid"
       [ngClass]="(isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left')"></i>
  </button>

  <!-- ── NAV ─────────────────────────────────────────────── -->
  <nav class="sb__nav" aria-label="Primary">
    <ul class="sb__list">
      <li class="sb__item" *ngFor="let link of links; let i = index"
          [class.sb__item--has-submenu]="link.hasSubmenu"
          [class.sb__item--open]="isSubmenuExpanded(link.id)">

        <!-- Single link -->
        <a *ngIf="!link.hasSubmenu" [routerLink]="link.link" routerLinkActive="active"
           class="sb__link" (click)="closeSidebar()">
          <span class="sb__link-icon"><i [class]="link.icon"></i></span>
          <span class="sb__link-label">{{ link.name | translate }}</span>
          <span class="sb__tooltip">{{ link.name | translate }}</span>
        </a>

        <!-- Parent link with submenu -->
        <ng-container *ngIf="link.hasSubmenu">
          <a class="sb__link sb__link--parent"
             [class.active]="hasActiveChild(link)"
             [class.is-open]="isSubmenuExpanded(link.id)"
             (click)="toggleSubmenu(link.id, $event)">
            <span class="sb__link-icon"><i [class]="link.icon"></i></span>
            <span class="sb__link-label">{{ link.name | translate }}</span>
            <i class="fa-solid fa-chevron-down sb__chevron"
               [class.sb__chevron--rotated]="isSubmenuExpanded(link.id)"></i>
            <span class="sb__tooltip">{{ link.name | translate }}</span>
          </a>

          <!-- Submenu items -->
          <ul class="sb__submenu"
              [class.sb__submenu--open]="isSubmenuExpanded(link.id)">
            <li class="sb__sub-item" *ngFor="let sublink of link.submenu">
              <a [routerLink]="sublink.link" routerLinkActive="active-submenu"
                 class="sb__sublink" (click)="closeSidebar()">
                <span class="sb__sub-dot" aria-hidden="true"></span>
                <span class="sb__sub-icon"><i [class]="sublink.icon"></i></span>
                <span class="sb__sublink-label">{{ sublink.name | translate }}</span>
              </a>
            </li>
          </ul>
        </ng-container>
      </li>
    </ul>
  </nav>

  <!-- ── PROFILE FOOTER ──────────────────────────────────── -->
  <footer class="sb__footer">
    <div class="sb__profile" *ngIf="userName">
      <div class="sb__avatar">
        <img [src]="userAvatar" [alt]="userName"
             onerror="this.onerror=null;this.src='assets/images/default-user.png'">
        <span class="sb__avatar-status" aria-hidden="true"></span>
      </div>
      <div class="sb__profile-text">
        <div class="sb__profile-name">{{ userName }}</div>
        <!-- <div class="sb__profile-role">{{ tierLabelKey(currentTier()) | translate }}</div> -->
      </div>
      <button class="sb__logout" type="button" (click)="logout()"
              [title]="'HEADER.LOGOUT' | translate"
              [attr.aria-label]="'HEADER.LOGOUT' | translate">
        <i class="fa-solid fa-arrow-right-from-bracket"></i>
      </button>
    </div>

    <!-- Un compte qui ouvre plusieurs espaces en change ici, sans se
         déconnecter. Un seul espace : rien à choisir, rien à montrer. -->
    @if (spaces.length > 1) {
      <app-space-switcher class="sb__spaces" variant="compact"
                          [spaces]="spaces" [current]="currentSpace()"
                          (select)="switchSpace($event)"></app-space-switcher>
    }
  </footer>

</aside>

<!-- Backdrop for mobile overlay -->
<div *ngIf="isSidebarOpen" class="sb-backdrop" (click)="closeSidebar()" aria-hidden="true"></div>
